// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

export async function getMachineStatusUpdates(payload) {

    const endPoint = (payload.export === 'EXCEL') ? `${basePath}/status-changes/collection?export=EXCEL&tcsm_flag=False` : `${basePath}/status-changes/collection?tcsm_flag=False`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return (payload.export === 'EXCEL') ? response : response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function putMachineStatusUpdates(payload) {

    const endPoint = `${basePath}/status-changes/${payload.id}`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (response) {

        return handleError(response);

    }

}



// WEBPACK FOOTER //
// ./src/product/machine-status-update/repositories/index.js